import type { Action } from 'src/types';

export enum Actions {
  SUGGESTIONS_UPDATE_SUCCESS = 'SUGGESTIONS_UPDATE_SUCCESS',
  SUGGESTIONS_UPDATE_FAILURE = 'SUGGESTIONS_UPDATE_FAILURE',
}

export type SuggestionsAction =
  | Action<Actions.SUGGESTIONS_UPDATE_SUCCESS>
  | (Action<Actions.SUGGESTIONS_UPDATE_FAILURE> & {
      payload: Error;
    });
